exports = module.exports = require("../../../../../../../usr/lib/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".besidaMob-notice__root--dMZYT{-ms-flex-align:center;-ms-flex-pack:center;-webkit-box-align:center;-webkit-box-pack:center;-webkit-box-sizing:border-box;align-items:center;box-sizing:border-box;display:-webkit-box;display:-ms-flexbox;display:flex;font-size:13px;height:100%;justify-content:center;padding:40px 0;text-align:center}.besidaMob-notice__imageHolder--eGa7Z{height:120px;margin:0 auto 30px;text-align:center;width:160px}.besidaMob-notice__image--2aaze{max-height:100%;max-width:100%;vertical-align:middle}.besidaMob-notice__title--AlrBd{color:#333;font-weight:700}.besidaMob-notice__content--3iqqk{color:#93949c;margin:10px 20px 0}", ""]);

// exports
exports.locals = {
	"root": "besidaMob-notice__root--dMZYT",
	"imageHolder": "besidaMob-notice__imageHolder--eGa7Z",
	"image": "besidaMob-notice__image--2aaze",
	"title": "besidaMob-notice__title--AlrBd",
	"content": "besidaMob-notice__content--3iqqk"
};